/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_Create_AdminInputs */

const en_admin_sidebar_create_admin = /** @type {(inputs: Admin_Sidebar_Create_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new admin account`)
};

const de_admin_sidebar_create_admin = /** @type {(inputs: Admin_Sidebar_Create_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Admin-Account erstellen`)
};

/**
* | output |
* | --- |
* | "Create new admin account" |
*
* @param {Admin_Sidebar_Create_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_create_admin = /** @type {((inputs?: Admin_Sidebar_Create_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_Create_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_create_admin(inputs)
	return en_admin_sidebar_create_admin(inputs)
});